import { ENotifyMethods, EEmployeeNotificationTypes, EExceptionUITypes, EExceptionType, ISupervisorNotificationSetting, IExtendedUserExceptionNotificationSetting, EExpenseScheduleTypeEnum } from "../models"
import strings from "../localization/strings"
import _ from "lodash"

export function getNotifyMethods(sendEmail: boolean, sendPush: boolean, sendSms: boolean, sendApp: boolean): ENotifyMethods[] {
    let notifyMethods: ENotifyMethods[] = []
    sendEmail &&
        notifyMethods.push(ENotifyMethods.Email)
    sendPush &&
        notifyMethods.push(ENotifyMethods.Push)
    sendSms &&
        notifyMethods.push(ENotifyMethods.Sms)
    sendApp &&
        notifyMethods.push(ENotifyMethods.App)
    return notifyMethods
}

export function getNotifyMethodsName(notifyMethods: ENotifyMethods[]): string {
    let notifyMethodsName: string = ""
    if (notifyMethods.includes(ENotifyMethods.Email)) {
        notifyMethodsName = strings.Email
    }
    if (notifyMethods.includes(ENotifyMethods.Push)) {
        notifyMethodsName = notifyMethodsName ? `${notifyMethodsName}, ${strings.Push}` : strings.Push
    }
    if (notifyMethods.includes(ENotifyMethods.Sms)) {
        notifyMethodsName = notifyMethodsName ? `${notifyMethodsName}, ${strings.SMS}` : strings.SMS
    }
    if (notifyMethods.includes(ENotifyMethods.App)) {
        notifyMethodsName = notifyMethodsName ? `${notifyMethodsName}, ${strings.App}` : strings.App
    }

    return notifyMethodsName
}

export function getEmployeeNotificationTypeName(notificationType: EEmployeeNotificationTypes) {
    switch (notificationType) {
        case EEmployeeNotificationTypes.ScheduleReminder:
            return strings.Schedule_Reminder
        case EEmployeeNotificationTypes.MissingInPunch:
            return strings.Missing_In_Punch
        case EEmployeeNotificationTypes.MissingOutPunch:
            return strings.Missing_Out_Punch
        case EEmployeeNotificationTypes.Timeoff:
            return strings.Time_off
        case EEmployeeNotificationTypes.SuspensePunch:
            return strings.Suspense_Punch
        case EEmployeeNotificationTypes.NewFile:
            return strings.New_File
        case EEmployeeNotificationTypes.NewJobShift:
            return strings.New_Job_Shift
        case EEmployeeNotificationTypes.AdHocCommunication:
            return strings.AdHoc_Communication
        case EEmployeeNotificationTypes.BadgeQualification:
            return strings.Badge_Qualification
    }
}

export function getExceptionTypeForUI(exceptionType: EExceptionType) {
    switch (exceptionType) {
        case EExceptionType.BIOMETRIC:
            return EExceptionUITypes.BioException
        case EExceptionType.LOCATION:
            return EExceptionUITypes.LocException
        case EExceptionType.MICRO_LOCATION:
            return EExceptionUITypes.LocException
        case EExceptionType.NO_DEVICE_LOCATION:
            return EExceptionUITypes.LocException
        case EExceptionType.NO_LOCATION_OR_MICROLOCATION:
            return EExceptionUITypes.LocException
        case EExceptionType.MISSING_PUNCH:
            return EExceptionUITypes.MissPunch
        case EExceptionType.MISSING_EMPLOYEE_APPROVAL:
            return EExceptionUITypes.NoEmpApprove
        case EExceptionType.MISSING_SUPERVISOR_APPROVAL:
            return EExceptionUITypes.NoSupApprove
        case EExceptionType.MISSING_IN_PUNCH:
            return EExceptionUITypes.ScheduleMissingInPunch
        case EExceptionType.EARLY_IN_PUNCH:
            return EExceptionUITypes.ScheduleEarlyInPunch
        case EExceptionType.LATE_IN_PUNCH:
            return EExceptionUITypes.ScheduleLateInPunch
        case EExceptionType.EARLY_OUT_PUNCH:
            return EExceptionUITypes.ScheduleEarlyOutPunch
        case EExceptionType.LATE_OUT_PUNCH:
            return EExceptionUITypes.ScheduleLateOutPunch
        case EExceptionType.MISSING_BREAK:
            return EExceptionUITypes.ScheduleMissingBreak
        case EExceptionType.LONG_BREAK:
            return EExceptionUITypes.ScheduleLongBreak
        case EExceptionType.NO_SHIFT:
            return EExceptionUITypes.ScheduleNoShift
        case EExceptionType.QUESTION_EXCEPTION:
            return EExceptionUITypes.QuestionException
        case EExceptionType.TIMEOFF:
            return EExceptionUITypes.Timeoff
        case EExceptionType.DEVICE_STATUS:
            return EExceptionUITypes.DeviceStatus
        case EExceptionType.SUSPENSE_PUNCH:
            return EExceptionUITypes.SuspensePunch
        case EExceptionType.TIME_FRAUD:
            return EExceptionUITypes.TimeFraud
        case EExceptionType.PUNCH_NOTE:
            return EExceptionUITypes.PunchNote
        case EExceptionType.CA_MEAL_BREAK:
            return EExceptionUITypes.CAMealBreakException
            case EExceptionType.MINIMUM_BREAK_OVERRIDE:
                return EExceptionUITypes.MinimumBreakOverride
    }
}

export function getExceptionTypeName(exceptionType: EExceptionUITypes) {
    switch (exceptionType) {
        case EExceptionUITypes.BioException:
            return strings.Biometric
        case EExceptionUITypes.LocException:
            return strings.Location
        case EExceptionUITypes.MissPunch:
            return strings.Missing_Punch
        case EExceptionUITypes.NoEmpApprove:
            return strings.Missing_Employee_Approval
        case EExceptionUITypes.NoSupApprove:
            return strings.Missing_Supervisor_Approval
        case EExceptionUITypes.ScheduleEarlyInPunch:
            return strings.Early_In_Punch
        case EExceptionUITypes.ScheduleEarlyOutPunch:
            return strings.Early_Out_Punch
        case EExceptionUITypes.ScheduleLateInPunch:
            return strings.Late_In_Punch
        case EExceptionUITypes.ScheduleLateOutPunch:
            return strings.Late_Out_Punch
        case EExceptionUITypes.ScheduleLongBreak:
            return strings.Long_Break
        case EExceptionUITypes.ScheduleMissingBreak:
            return strings.Missing_Break
        case EExceptionUITypes.ScheduleMissingInPunch:
            return strings.Missing_In_Punch
        case EExceptionUITypes.ScheduleNoShift:
            return strings.No_Shift
        case EExceptionUITypes.QuestionException:
            return strings.Question_Exception
        case EExceptionUITypes.Timeoff:
            return strings.Time_off
        case EExceptionUITypes.DeviceStatus:
            return strings.Device_Connect_Status
        case EExceptionUITypes.SuspensePunch:
            return strings.Suspense_Punch
        case EExceptionUITypes.TimeFraud:
            return strings.Time_Fraud
        case EExceptionUITypes.PunchNote:
            return strings.Punch_Comment
        case EExceptionUITypes.CAMealBreakException:
            return strings.CA_Meal_Break_Exception
            case EExceptionUITypes.MinimumBreakOverride:
                return strings.Minimum_Break_Override
    }
}

export function convertSubscriptionsToSubscriptionsForUI(subscriptions: ISupervisorNotificationSetting[]): IExtendedUserExceptionNotificationSetting[] {
    // we need return one Location item for 4 exceptions (LOCATION, MICRO_LOCATION, NO_LOCATION_OR_MICROLOCATION, NO_DEVICE_LOCATION)
    return subscriptions
        .filter(i => ![EExceptionType.MICRO_LOCATION, EExceptionType.NO_DEVICE_LOCATION, EExceptionType.NO_LOCATION_OR_MICROLOCATION].includes(i.ExceptionType))
        .map((subscription, index) => {
            const subscriptionForUI: IExtendedUserExceptionNotificationSetting = { Id: index, ExceptionTypeForUI: getExceptionTypeForUI(subscription.ExceptionType), ...subscription }
            return subscriptionForUI
        })
}

export function convertSubscriptionsForUIToSubscriptions(subscriptionsForUI: IExtendedUserExceptionNotificationSetting[]): ISupervisorNotificationSetting[] {
    let subscriptions: ISupervisorNotificationSetting[] = []
    subscriptionsForUI.forEach(item => {
        if (item.ExceptionTypeForUI !== EExceptionUITypes.LocException) {
            let exceptionType: EExceptionType
            switch (item.ExceptionTypeForUI) {
                case EExceptionUITypes.BioException:
                    exceptionType = EExceptionType.BIOMETRIC
                    break
                case EExceptionUITypes.MissPunch:
                    exceptionType = EExceptionType.MISSING_PUNCH
                    break
                case EExceptionUITypes.NoEmpApprove:
                    exceptionType = EExceptionType.MISSING_EMPLOYEE_APPROVAL
                    break
                case EExceptionUITypes.NoSupApprove:
                    exceptionType = EExceptionType.MISSING_SUPERVISOR_APPROVAL
                    break
                case EExceptionUITypes.ScheduleEarlyInPunch:
                    exceptionType = EExceptionType.EARLY_IN_PUNCH
                    break
                case EExceptionUITypes.ScheduleEarlyOutPunch:
                    exceptionType = EExceptionType.EARLY_OUT_PUNCH
                    break
                case EExceptionUITypes.ScheduleLateInPunch:
                    exceptionType = EExceptionType.LATE_IN_PUNCH
                    break
                case EExceptionUITypes.ScheduleLateOutPunch:
                    exceptionType = EExceptionType.LATE_OUT_PUNCH
                    break
                case EExceptionUITypes.ScheduleLongBreak:
                    exceptionType = EExceptionType.LONG_BREAK
                    break
                case EExceptionUITypes.ScheduleMissingBreak:
                    exceptionType = EExceptionType.MISSING_BREAK
                    break
                case EExceptionUITypes.ScheduleMissingInPunch:
                    exceptionType = EExceptionType.MISSING_IN_PUNCH
                    break
                case EExceptionUITypes.ScheduleNoShift:
                    exceptionType = EExceptionType.NO_SHIFT
                    break
                case EExceptionUITypes.QuestionException:
                    exceptionType = EExceptionType.QUESTION_EXCEPTION
                    break
                case EExceptionUITypes.Timeoff:
                    exceptionType = EExceptionType.TIMEOFF
                    break
                case EExceptionUITypes.DeviceStatus:
                    exceptionType = EExceptionType.DEVICE_STATUS
                    break
                case EExceptionUITypes.SuspensePunch:
                    exceptionType = EExceptionType.SUSPENSE_PUNCH
                    break
                case EExceptionUITypes.TimeFraud:
                    exceptionType = EExceptionType.TIME_FRAUD
                    break
                case EExceptionUITypes.PunchNote:
                    exceptionType = EExceptionType.PUNCH_NOTE
                    break
                case EExceptionUITypes.CAMealBreakException:
                    exceptionType = EExceptionType.CA_MEAL_BREAK
                    break
                    case EExceptionUITypes.MinimumBreakOverride:
                        exceptionType = EExceptionType.MINIMUM_BREAK_OVERRIDE
                        break
            }
            delete item.Id
            delete item.ExceptionTypeForUI
            item.ExceptionType = exceptionType
            subscriptions.push(item)
        }
        else {
            delete item.Id
            delete item.ExceptionTypeForUI
            const subscription1 = _.cloneDeep(item)
            subscription1.ExceptionType = EExceptionType.LOCATION
            const subscription2 = _.cloneDeep(item)
            subscription2.ExceptionType = EExceptionType.MICRO_LOCATION
            const subscription3 = _.cloneDeep(item)
            subscription3.ExceptionType = EExceptionType.NO_LOCATION_OR_MICROLOCATION
            const subscription4 = _.cloneDeep(item)
            subscription4.ExceptionType = EExceptionType.NO_DEVICE_LOCATION
            subscriptions.push(subscription1, subscription2, subscription3, subscription4)
        }
    })
    return subscriptions
}


